import { useEffect, useState } from "react";
import MenuItem from "../../models/MenuItem";
import MenuItemComponent from "./MenuItemComponent";
import { supabase } from "../../services/supabase/SupabaseClient";
import MenuMapper from "../../utils/mappers/MenuMapper";
import FadeInComponent from "../ui/FadeInComponent";

const defaultFeaturedList: MenuItem[] = [
    {
        id: 1,
        name: "Grilled Beef Back Rib Pho (Non-GF)",
        description:
            "Grilled marinated beef back rib served with rice noodle in beef broth and a fried egg, garnish with white onion, green onion, and cilantro.\nSide: bean sprout, basil, lime, jalapeno.\nSauce: hoisin and sriracha.",
        price: 19.99,
        imgUrl: '',
    },
    {
        id: 2,
        name: "House Crispy Noodle",
        description:
            "Five jumbo shrimp and cube filet mignon stir fry with mix vegetables in house sauce, served in crispy egg noodle.",
        price: 17.99,
        imgUrl: '',
    },
    {
        id: 3,
        name: "Garlic Butter Popcorn Chicken",
        description:
            "Crispy fried popcorn chicken, toss with garlic butter sauce, served with sweet and sour sauce.",
        price: 12.99,
        imgUrl: '',
    },
    {
        id: 4,
        name: "Grilled Pork Skewers (1)",
        description:
            "Grilled pork meat on the stick, served with pickled carrots and daikon, parsley flakes for garnish.",
        price: 15.99,
        imgUrl: '',
    },
    {
        id: 5,
        name: "Vietnamese Chicken Curry |Mild Spicy|",
        description:
            "Bone-in dark meat chicken\nPotato, carrot, white onion\nChoice: Steamed Rice, Baguette, Rice Noodle, Vermicelli Noodle.",
        price: 14.49,
        imgUrl: '',
    },
    {
        id: 6,
        name: "Shaken Filet Mignon Fries",
        description:
            "Cube filet mignon, garlic butter fries Green onion, white onion Ranch and ketchup",
        price: 18.99,
        imgUrl: '',
    },
];

function FeaturedMenu() {
    const [featuredList, setFeaturedList] =
        useState<MenuItem[]>(defaultFeaturedList);

    useEffect(() => {
        let isMounted = true;

        const loadFeaturedItems = async () => {
            try {
                const { data, error } = await supabase
                    .from("menu_items")
                    .select("*")
                    .eq("featured", true);

                if (error) {
                    console.error("Failed to fetch featured menu items:", error);
                    return;
                }

                if (!data || data.length === 0) return;

                const mappedItems = MenuMapper.toMenuItem(data);

                if (isMounted) {
                    setFeaturedList(mappedItems);
                }
            } catch (error) {
                console.error("Featured menu request rejected:", error);
            }
        };

        loadFeaturedItems();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <section id="featuredMenu">
            <FadeInComponent className="container-fluid pt-4 pb-5 px-3">
                <div className="d-flex flex-column justify-content-center align-items-center my-heading text-center">
                    <h2>Featured Menu</h2>

                    <p>
                        Our most popular dishes, savored time and time again
                        by our beloved customers
                    </p>
                </div>

                <div className="container mt-2">
                    <div className="row">
                        {featuredList.map((item) => (
                            <MenuItemComponent
                                key={item.id}
                                item={item}
                            />
                        ))}
                    </div>
                </div>

                <div className="d-flex justify-content-center mt-3">
                    <a
                        href="https://aloasiankitchen.org/documents/menu.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-alo"
                    >
                        View Digital Menu
                    </a>
                </div>
            </FadeInComponent>
        </section>
    );
}

export default FeaturedMenu;